"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";
import { isEmptyValue } from "D5Utils/functions";

var BaseTwinControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(BaseTwinControl, _BaseControl);

  // this._type implemented in children
  function BaseTwinControl(props) {
    var _this;

    _classCallCheck(this, BaseTwinControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseTwinControl).call(this, props));

    if (_this.value == null) {
      _this.value = [];
    } else if (!Array.isArray(_this.value)) {
      _this.value = [_this.value];
    }

    _this.$_element = $('<div class="field-container-between"/>');
    _this.$fieldFrom = $("<div id='field-container-".concat(_this.props.dataField, "-from' class=\"d5-field\"/>"));
    _this.$fieldTo = $("<div id='field-container-".concat(_this.props.dataField, "-to' class=\"d5-field to\"/>"));
    return _this;
  }

  _createClass(BaseTwinControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps(data) {
      var _this2 = this;

      return {
        elementAttr: {
          'data-from': this.value[0],
          'data-to': this.value[1]
        },
        value: this.value[0],
        onValueChanged: function onValueChanged(e) {
          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged({
              value: [e.value, e.element.attr('data-to')]
            });
          }
        }
      };
    }
  }, {
    key: "_buildControlToProps",
    value: function _buildControlToProps() {
      var _this3 = this;

      return {
        value: this.value[1],
        onValueChanged: function onValueChanged(e) {
          _this3.$fieldFrom.attr('data-to', e.value);
        }
      };
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      var value = isEmptyValue(newValue) ? [] : newValue;

      this.$fieldFrom[this._type]('option', 'value', value[0]);

      this.$fieldTo[this._type]('option', 'value', value[1]);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$fieldFrom[this._type]('dispose');

      this.$fieldTo[this._type]('dispose');

      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      this.$fieldFrom = this.$fieldFrom[this._type](_objectSpread({}, this._buildControlProps()));
      this.$fieldTo = this.$fieldTo[this._type](_objectSpread({}, this._buildControlToProps())).dxValidator({
        validationGroup: 'fieldToGroup',
        validationRules: [{
          type: 'custom',
          validationCallback: function validationCallback(options) {
            return _this4._comparisonTarget(options);
          },
          message: "Must be greater or equal than the field 'TO'"
        }]
      });
      this.$_element.append(this.$fieldFrom, this.$fieldTo);
    }
  }, {
    key: "_comparisonTarget",
    value: function _comparisonTarget(options) {// throw new Error('Must be implemented in a child')
    }
  }]);

  return BaseTwinControl;
}(BaseControl);

export { BaseTwinControl as default };